import { render } from "./CardHistorique.vue?vue&type=template&id=1020cd80&scoped=true"
import script from "./CardHistorique.vue?vue&type=script&lang=js"
export * from "./CardHistorique.vue?vue&type=script&lang=js"

import "./CardHistorique.vue?vue&type=style&index=0&id=1020cd80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1020cd80"]])

export default __exports__